




























import Vue from 'vue';

// Components
import Card from './Card.vue';
import Icon from '~/components/builders/Base/Icon.vue';
import Button from '~/components/builders/Base/Button.vue';

export default Vue.extend({
    name: 'EmptyProfileInfo',
    components: { Card, Icon, Button },
});
